<template>
  <modal width="55" :show-modal="showModal" @close-modal="$emit('close-modal')" title="Tier History">
    <div class="delete-modal">
      <p class="w-full text-left my-3">
        <span class="pr-4">Current Tier</span>
        <span class="px-2 py-2 bg-backgroundGrey rounded">{{ priceHistory.currentTier || 'N/A' }} {{ priceHistory.changes || '0' }}%</span>
      </p>
      <div>
        <p class="text-left pt-3 pb-2">Fleet Type</p>
        <div class="flex justify-between items-center w-full">
          <div class="w_semi">
            <el-select v-model="fleetType" placeholder="Select handling Requirements" class="mb-0">
              <el-option value="--Select--">-- Select -- </el-option>
              <el-option v-for="option in shipmentCategories" :key="option" :label="option" :value="option">
              </el-option>
            </el-select>
          </div>
          <div class="w_semi h-full bg-slate-400">

            <el-dropdown trigger="click" class="h-full w-full">
              <div class="drp-content">
                <span>
                  <img src="../icons/CalendarIcon.svg" />
                  <abbr class="vrt_line"></abbr>
                  This month
                </span>
                <ArrowDownBlackIcon :style="{ width: '15px', height: '17px' }" color="black" />
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <button>This month</button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

      <div>
        <table class="custom-table responsive-table border-collapse">
          <thead class="font-normal">
            <tr class="rounded-lg bg-backgroundGrey">
              <th>End Date</th>
              <th>Total Transactions</th>
              <th>Gross Revenue(₦)</th>
              <th>Tier Equivalent</th>
            </tr>
          </thead>
          <tbody v-if="!loading">
            <tr v-for="(priceTier) in priceHistory.teirHistory" :key="priceTier.id"
              class="rounded-lg border-b-[1px] border-gray-500">
              <td>
                {{ priceTier.endDate }}
              </td>
              <td>
                {{ priceTier.totalTransactionCount || '0' }}
              </td>
              <td>{{ formatAmount(priceTier.grossRevenue) }}</td>
              <td>
                {{  priceTier.teirEquivalent || '0' }}
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal>
</template>

<script>
import ArrowDownBlackIcon from "@/components/UI/svgs/ArrowDownBlackIcon.vue";

export default {
  components: {
    ArrowDownBlackIcon
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      shipmentCategories: ["Bike", "Truck", "Car", "Lorry"],
      fleetType: 'Bike',
      priceHistory: {}
    };
  },
  watch: {
    showModal(val) {
      if (val) {
        this.getPriceHistory()
      }
    },
    fleetType(){
      this.getPriceHistory()
    }
  },
  methods: {
    formatAmount(number) {
      return number ? number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    },
    async getPriceHistory() {
      const payload = {
        customerType: '3PL',
        fleetType: this.fleetType
      }
      let response = await this. $_getViewPriceHistory(payload)
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>", response)
      this.priceHistory = response.data.data
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}

.w_semi {
  @apply w-[48%] flex items-center
}

.drp-content {
  @apply w-full border-[1px] h-full py-[8px] rounded flex items-center justify-between px-2;

  span {
    @apply flex items-center
  }
}

.vrt_line {
  @apply w-[1px] h-[17px] bg-gray-400 inline-block mx-2
}

td {
  text-align: left;
}

th {
  text-align: left;
}
</style>
